import React, { useState, useEffect } from 'react';
import { Empty, message, Card, Typography, Collapse, Divider, Row, Col, Spin, Popover } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from "react-router-dom"
import { useExcryptedNavigation } from '../Filters/FilterConditions';
import { getAllUsersData, FetchDealByEntity } from "../../../Api/Services/CommonApiService";
import { CaseIcon } from '../../../components/Icons/Icons';
import CustomHtmlParser from '../Email/CustomHtmlParser'

const { Text } = Typography; // Title,
const { Panel } = Collapse;

const DealTable = ({ UrlId, refreshTrigger, tabKey }) => {
    const history = useHistory();
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const [allUsers, setAllUsers] = useState()
    const [apiType, setApiType] = useState()
    const [dealsList, setDealsList] = useState()
    const [openPage, setOpenPage] = useState(Array(dealsList?.length).fill(false));
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const handleOpenPageChange = (index) => {
        const newPopoverOpenStates = [...openPage];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage(newPopoverOpenStates);
    };
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    async function AllUsersData() {
        try {
            const data = await getAllUsersData();
            setAllUsers(data);
        } catch (error) {
            message.error(error)
        }
    }
    async function AllDeal() {
        if (UrlId !== undefined && UrlId !== null && (UrlId[0] === "?LEAD" || UrlId[0] === "?DEAL" || UrlId[0] === "?CONTACT" || UrlId[0] === "?ACCOUNT" || UrlId[0] === "?TASK")) {
            if (apiType === "Task") {
                try {
                    const response = await FetchDealByEntity(UrlId[1], "Case")
                    const SortedData = response.sort((a, b) => b.caseId - a.caseId);
                    const dataWithCurrency = await Promise.all(
                        SortedData.map(async item => {
                            return {
                                ...item,
                                DataPermission: { isPresent: item.allow, CaseLinkType: item.entityPermissionType }
                            };
                        }));
                    setDealsList(dataWithCurrency)
                }
                catch (error) {
                    message.error(error)
                }
            }
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            AllUsersData(),
        ])
    };
    useEffect(() => {
        fetchAll()
        if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
            setApiType("Lead")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
            setApiType("Deal")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
            setApiType("Contact")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
            setApiType("Account")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK") {
            setApiType("Task")
        }
    }, [])
    useEffect(() => {
        if (UrlId && UrlId[1] && apiType) {
            if (refreshTrigger === tabKey) {
                AllDeal()
            }
        }
    }, [UrlId, apiType, refreshTrigger, tabKey])
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";

        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);

        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }

        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone);

        // Check if the date is today in the same target timezone
        const today = moment.tz(toTimezone).startOf('day');
        const isToday = converted.isSame(today, 'day');

        if (isToday) {
            return "Today";
        }
        const formattedDate = converted.format("MMM DD, YYYY");
        return formattedDate
    }
    return (
        <>
            <>
                {dealsList ? (dealsList?.length > 0 ?
                    dealsList.map((item, index) => {
                        const user = allUsers?.find(user => user.userId === item.caseOwner);
                        const Name = user ? `${user.firstName} ${user.lastName}` : "Unknown User";
                        const formattedTimeDifference = convertAndFormatDateTime2(item.createdAt, companyProfile, profile)
                        return (
                            <div key={index} style={{ marginBottom: 15 }}>
                                <Card className="DetailsTabCard">
                                    <Collapse bordered={false} className="DetailsTabCollapse">
                                        <Panel
                                            header={
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <CaseIcon height={16} width={16} marginRight={5} />
                                                    <Text strong>{item.caseSubject} ({item.caseNumber})</Text>
                                                    <div style={{ display: "none" }}><Text strong> Case by {Name}</Text></div>
                                                </div>
                                            }
                                            key="1"
                                            extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}
                                                </div>
                                                {item.DataPermission.isPresent &&
                                                    <Popover
                                                        placement="bottom"
                                                        content={
                                                            <div >
                                                                <div className="text_icon newHover-class"
                                                                    role="button"
                                                                    tabIndex={0} title='View Details'
                                                                    onClick={() => {
                                                                        ViewDetailPage(item.caseId, item.DataPermission?.CaseLinkType)
                                                                        handleOpenPageChange(index)
                                                                    }}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                            ViewDetailPage(item.caseId, item.DataPermission?.CaseLinkType)
                                                                            handleOpenPageChange(index)
                                                                        }
                                                                    }}
                                                                    aria-label='view'>
                                                                    <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                </div>
                                                            </div>
                                                        }
                                                        trigger="hover"
                                                        open={openPage[index]}
                                                        onOpenChange={() => handleOpenPageChange(index)}
                                                    >
                                                        <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                    </Popover>}
                                            </div>}
                                        >
                                            <Divider style={{ margin: 0 }} />
                                            {/* <Title level={5} style={{ marginTop: 10 }}>
                                                <Text strong style={{ marginRight: 5 }}>{item.caseSubject} ({item.caseNumber})</Text>
                                            </Title> */}
                                            <div style={{ marginTop: 10 }}>
                                                <Text type="secondary">{item.description && item.description !== "" ? <CustomHtmlParser html={item.description} key={index} page="Previewss" /> : "Case Description"}</Text>
                                            </div>
                                            <Divider style={{ margin: "10px 0" }} />
                                            <Row gutter={16}>
                                                <Col span={7} style={{
                                                    borderRight: "1px solid #dddddd"
                                                }}>
                                                    <Text type="secondary" className='RightSide-Lable'>Case Status</Text>
                                                    <br />
                                                    <Text>{item.caseStatus}</Text>
                                                </Col>
                                                <Col span={7} style={{
                                                    borderRight: "1px solid #dddddd"
                                                }}>
                                                    <Text type="secondary" className='RightSide-Lable'>Case Type</Text>
                                                    <br />
                                                    <Text>{item.caseType}</Text>
                                                </Col>
                                                <Col span={10}>
                                                    <Text type="secondary" className='RightSide-Lable'>Resolution Date</Text>
                                                    <br />
                                                    <Text>{item.requestedResolutionDate && profile?.dateFormate ? moment(item.requestedResolutionDate).format(profile?.dateFormate) : (item.requestedResolutionDate && moment(item.requestedResolutionDate).format("YYYY-MM-DD"))}</Text>
                                                </Col>
                                            </Row>
                                        </Panel>
                                    </Collapse>
                                </Card>
                            </div>
                        )
                    }) :
                    <div style={{ padding: "10%" }}>
                        <Empty />
                    </div>
                ) :
                    <div className="spin">
                        <Spin />
                    </div>
                }
            </>
        </>
    );
}
DealTable.propTypes = {
    UrlId: PropTypes.array.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(DealTable)